import { CirclePacking } from '../../../models/circlePackingModel';

import * as d3 from 'd3';

export const dataRange: (data: CirclePacking) => Array<number> = (data) => d3.extent(data.children, (d) => d.value);
